import { render, staticRenderFns } from "./inputCargo.vue?vue&type=template&id=af15418e&scoped=true&"
import script from "./inputCargo.vue?vue&type=script&lang=js&"
export * from "./inputCargo.vue?vue&type=script&lang=js&"
import style0 from "./inputCargo.vue?vue&type=style&index=0&id=af15418e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af15418e",
  null
  
)

export default component.exports